module.exports = __webpack_public_path__ + "img/pos3_txt.42d8e900.png";